import React from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import Home from './pages/Home';
import AboutMe from './pages/AboutMe';
import Skills from './pages/Skills';
import Examples from './pages/Examples';
import Contact from './pages/Contact';
import Header from './global/Header';
import Footer from './global/Footer';
import './styles.css';

const Layout: React.FC<{ children: React.ReactNode }> = ({ children }) => {
  // Apply global styles to remove default browser margins/padding
  React.useEffect(() => {
    document.body.style.margin = '0';
    document.body.style.padding = '0';
    document.documentElement.style.margin = '0';
    document.documentElement.style.padding = '0';
  }, []);

  return (
    <div className="layout">
      <Header />
      
      <main className="main">
        {children}
      </main>
      
      <Footer />
    </div>
  );
};


const App: React.FC = () => {
  return (
    <Router>
      <Layout>
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/about" element={<AboutMe />} />
          <Route path="/skills" element={<Skills />} />
          <Route path="/examples" element={<Examples />} />
          <Route path="/contact" element={<Contact />} />
          <Route path="*" element={<Navigate to="/" replace />} />
        </Routes>
      </Layout>
    </Router>
  );
};

export default App;